import * as React from "react";
import "../styles/BenefitItem.css";

export function BenefitItem({icon, heading, children}) {
    return <div className="benefit-item card">
        <div className="icon">
            {icon}
        </div>
        <div className="heading font-body-L">
            {heading}
        </div>
        <p className={"font-body-M-Regular"}>
            {children}
        </p>
    </div>
}
